import { BodyFormExercise } from '../components/BodyFormExercise';

export const AddExercisesPage = () => {
  return <BodyFormExercise />;
};
